module.exports = __webpack_public_path__ + "static/media/04_720.2799de72.jpeg";